(function () {
  'use strict';

  var root = document.documentElement;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var revealObserver = null;

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function addClassOnce(element, className) {
    if (element && !element.classList.contains(className)) {
      element.classList.add(className);
    }
  }

  function removeClass(element, className) {
    if (element && element.classList.contains(className)) {
      element.classList.remove(className);
    }
  }

  function uniqueElements(scope, selectors) {
    var found = new Set();
    selectors.forEach(function (selector) {
      toArray(scope.querySelectorAll(selector)).forEach(function (element) {
        found.add(element);
      });
    });
    return Array.from(found);
  }

  function isExcluded(element) {
    return Boolean(element.closest('.header-wrapper, .footer, .menu-drawer, .predictive-search'));
  }

  function isInsideRevealGroup(element) {
    return Boolean(element.closest('.ksc-reveal-group'));
  }

  function ensureOverlayLayer(container) {
    if (!container) return;
    if (container.querySelector(':scope > .ksc-image-hover__overlay')) {
      addClassOnce(container, 'ksc-image-hover--has-overlay');
      return;
    }
    var overlay = document.createElement('span');
    overlay.className = 'ksc-image-hover__overlay';
    overlay.setAttribute('aria-hidden', 'true');
    container.appendChild(overlay);
    addClassOnce(container, 'ksc-image-hover--has-overlay');
  }

  function enhanceImageContainers(scope) {
    var imageContainers = uniqueElements(scope, [
      '.card__media',
      '.article-card__image-wrapper',
      '.multicolumn-card__image-wrapper',
      '.collection-hero__image-container',
      '.image-with-text__media',
      '.banner__media',
      '.timeline-item_image',
      '.ecom__element.element__image'
    ]);

    imageContainers.forEach(function (container) {
      addClassOnce(container, 'ksc-image-hover');
      addClassOnce(container, 'ksc-image-hover--zoom');
      addClassOnce(container, 'ksc-image-hover--fade');
      ensureOverlayLayer(container);

      removeClass(container, 'ksc-overlay-fade');
      removeClass(container, 'image-container-hover');

      toArray(container.querySelectorAll('img, video')).forEach(function (media) {
        addClassOnce(media, 'ksc-image-hover__media');
      });
    });
  }

  function enhanceCards(scope) {
    uniqueElements(scope, [
      '.card-wrapper',
      '.article-card-wrapper',
      '.multicolumn-card',
      '.collection-list .card',
      '.product-card-wrapper .card'
    ]).forEach(function (card) {
      addClassOnce(card, 'ksc-card-hover');
    });
  }

  function enhanceHoverContent(scope) {
    uniqueElements(scope, [
      '.card__information',
      '.card__badge',
      '.banner__content',
      '.article-card__info',
      '.multicolumn-card__info'
    ]).forEach(function (element) {
      if (!element.closest('.ksc-image-hover')) return;
      addClassOnce(element, 'ksc-image-hover__content');
    });
  }

  function enhanceRevealTargets(scope) {
    uniqueElements(scope, [
      '.image-with-text__media-item',
      '.image-with-text__content',
      '.card-wrapper',
      '.article-card-wrapper',
      '.collection-list .card-wrapper',
      '.multicolumn-card',
      '.timeline-item_image',
      '.ecom__element.element__image'
    ]).forEach(function (element) {
      if (isExcluded(element)) return;
      if (isInsideRevealGroup(element)) return;
      removeClass(element, 'ksc-reveal');
      removeClass(element, 'ksc-reveal-visible');
      addClassOnce(element, 'ksc-image-reveal');
    });
  }

  function enhanceRevealGroups(scope) {
    var groups = [
      { container: '.multicolumn-list', children: ':scope > li' },
      { container: '.blog-articles', children: ':scope > *' },
      { container: '.grid.product-grid', children: ':scope > li' },
      { container: '.collection-list .grid', children: ':scope > li' },
      { container: '.ecom-timeline_grid', children: ':scope > .ecom-timeline_item' }
    ];

    groups.forEach(function (groupDef) {
      toArray(scope.querySelectorAll(groupDef.container)).forEach(function (group) {
        if (isExcluded(group)) return;
        addClassOnce(group, 'ksc-reveal-group');

        toArray(group.querySelectorAll(groupDef.children)).forEach(function (child, index) {
          removeClass(child, 'ksc-reveal');
          removeClass(child, 'ksc-reveal-visible');
          addClassOnce(child, 'ksc-image-reveal');
          child.style.setProperty('--ksc-reveal-index', String(index));
        });
      });
    });
  }

  function revealNow(element) {
    if (element.classList.contains('ksc-image-reveal-visible')) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        element.classList.add('ksc-image-reveal-visible');
      });
    });
  }

  function bindRevealObserver(scope) {
    var groups = toArray(scope.querySelectorAll('.ksc-reveal-group'));
    var allTargets = toArray(scope.querySelectorAll('.ksc-image-reveal'));
    var individualTargets = allTargets.filter(function (target) {
      return !target.closest('.ksc-reveal-group');
    });

    if (!groups.length && !individualTargets.length) return;

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      allTargets.forEach(revealNow);
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            window.setTimeout(function () {
              revealNow(entry.target);
            }, 60);
            revealObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.08,
          rootMargin: '0px 0px -6% 0px'
        }
      );
    }

    individualTargets.forEach(function (target) {
      if (target.classList.contains('ksc-image-reveal-visible')) return;
      revealObserver.observe(target);
    });

    groups.forEach(function (group) {
      if (group.dataset.kscRevealGroupBound === 'true') return;
      group.dataset.kscRevealGroupBound = 'true';

      var groupChildren = Array.from(
        new Set(toArray(group.querySelectorAll(':scope > .ksc-image-reveal, :scope > * .ksc-image-reveal')))
      );
      if (!groupChildren.length) return;

      var groupObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            groupChildren.forEach(function (child, index) {
              if (child.classList.contains('ksc-image-reveal-visible')) return;
              var delay = 80 + Math.min(index, 7) * 85;
              window.setTimeout(function () {
                revealNow(child);
              }, delay);
            });
            groupObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.05,
          rootMargin: '0px 0px -4% 0px'
        }
      );

      groupObserver.observe(group);
    });
  }

  function init(scope) {
    var rootScope = scope || document;
    root.classList.add('ksc-image-motion-ready');

    enhanceImageContainers(rootScope);
    enhanceCards(rootScope);
    enhanceHoverContent(rootScope);
    enhanceRevealGroups(rootScope);
    enhanceRevealTargets(rootScope);
    bindRevealObserver(rootScope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  window.addEventListener('load', function () {
    init(document);
  });

  window.setTimeout(function () {
    init(document);
  }, 600);

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target || document);
    });

    document.addEventListener('shopify:section:reorder', function () {
      init(document);
    });

    document.addEventListener('shopify:block:select', function (event) {
      init((event.target && event.target.closest('.shopify-section')) || document);
    });
  }
})();
